"use strict";

exports.__esModule = true;
exports.default = void 0;
var _moment = _interopRequireDefault(require("moment"));
var _actions = _interopRequireDefault(require("./actions"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var _default = exports.default = {
  Id: {
    displayName: 'ID',
    type: 'String',
    guarded: true,
    sortable: true,
    filterable: true,
    visible: false
  },
  ContentFileImage: {
    displayName: 'Thumbnail',
    type: 'RelationPicture',
    rules: [],
    value: '',
    format: 'base64',
    entity: {
      local: 'ContentFile',
      foreign: 'ContentFileImage'
    },
    add: _actions.default.addPicture,
    update: _actions.default.updatePicture,
    drop: _actions.default.dropPicture,
    sortable: true,
    filterable: false
  },
  DisplayName: {
    displayName: 'Display Name',
    key: 'displayName',
    type: 'String',
    rules: [],
    value: '',
    sortable: true,
    filterable: true
  },
  Name: {
    // File name (e.g. "image001.jpg")
    displayName: 'File Name',
    key: 'name',
    type: 'String',
    rules: [],
    value: '',
    sortable: true,
    filterable: true
  },
  ContentFileLanguages: {
    displayName: 'Languages',
    type: 'Join',
    entities: {
      local: 'ContentFile',
      join: 'ContentFileLanguages',
      foreign: 'Language',
      filterString: value => `DisplayName != null and DisplayName.Contains("${value}")`,
      getDisplayName: entity => `${entity.DisplayName}`,
      displayName: 'DisplayName'
    },
    add: _actions.default.addLanguage,
    drop: _actions.default.dropLanguage,
    sortable: false,
    filterable: false
  },
  ProductViShowContentFiles: {
    displayName: 'Products',
    type: 'Join',
    entities: {
      local: 'ViShowContentFile',
      join: 'ProductViShowContentFiles',
      foreign: 'Product',
      filterString: value => `Name != null and Name.Contains("${value}")`,
      getDisplayName: entity => `${entity.Name}`,
      displayName: 'Name'
    },
    add: _actions.default.addProduct,
    drop: _actions.default.dropProduct,
    sortable: false,
    filterable: false
  },
  ShowroomViShowContentFiles: {
    displayName: 'Showrooms',
    type: 'Join',
    entities: {
      local: 'ViShowContentFile',
      join: 'ShowroomViShowContentFiles',
      foreign: 'Showroom',
      filterString: value => `Name != null and Name.Contains("${value}")`,
      getDisplayName: entity => `${entity.Name}`,
      displayName: 'Name'
    },
    add: _actions.default.addShowroom,
    drop: _actions.default.dropShowroom,
    sortable: false,
    filterable: false
  },
  Type: {
    displayName: 'Type',
    type: 'Enum',
    options: {
      0: 'Undefined',
      // Default value, type has not been specified
      1: 'Other',
      // The type is well known however not listed in this enumeration yet
      2: 'Document',
      3: 'Pdf',
      4: 'Image',
      5: 'Audio',
      6: 'Video',
      7: 'AssetBundle'
    },
    guarded: true,
    sortable: true
  },
  Hash: {
    displayName: 'Hash',
    type: 'String',
    rules: [],
    value: '',
    sortable: true,
    filterable: true,
    visible: false
  },
  Size: {
    // Size of the file in bytes
    displayName: 'Size',
    key: 'size',
    type: 'Number',
    rules: [],
    value: '',
    guarded: true,
    sortable: true,
    filterable: false,
    format: (bytes, decimals = 1) => {
      if (bytes === 0) return '0 Bytes';
      const k = 1024;
      const dm = decimals < 0 ? 0 : decimals;
      const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
    }
  },
  UpdatedAt: {
    displayName: 'Updated',
    type: 'Date',
    format: value => value ? (0, _moment.default)(value).format('DD.MM.YYYY') : null,
    guarded: true,
    sortable: true,
    filterable: true
  },
  CreatedAt: {
    displayName: 'Created',
    type: 'Date',
    format: value => value ? (0, _moment.default)(value).format('DD.MM.YYYY') : null,
    guarded: true,
    sortable: true,
    filterable: true
  },
  OwnerId: {
    displayName: 'Owner ID',
    type: 'String',
    guarded: true,
    sortable: true,
    filterable: true,
    visible: false
  }
};
module.exports = exports.default;